<template>
  <header class="header">
    <div class="header-left">
      <img src="@/assets/logo_kz.svg" alt="Logo" class="logo"  style="    height: 56px;  "/>
    </div>

    <div class="header-right">
      <span class="username">{{ username }}</span>
      <el-button type="text" class="logout-button" @click="handleLogout">
        <font-awesome-icon :icon="['fas', 'sign-out-alt']" />
      </el-button>
    </div>
  </header>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
import authService from "../services/authService";

export default defineComponent({
  name: "HeaderComponent",
  setup() {
    const username = ref(localStorage.getItem("username") || "Guest");
    const router = useRouter();

    const handleLogout = () => {
      authService.logout();
      router.push("/login");
    };

    return {
      username,
      handleLogout,
    };
  },
});
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  background-color: white;
  color: black;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header-left {
  display: flex;
  align-items: center;
}

.logo {
  height: 10%;
  object-fit: contain;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 15px;
}

.username {
  font-size: 16px;
  font-weight: bold;
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.logout-button {
  font-size: 20px;
  color: black;
  cursor: pointer;
  transition: color 0.3s; /* Added transition for hover effect */
}

.logout-button:hover {
  color: #ff4d4d; /* Change color on hover */
}
</style>
